'use client'

import HomeCard2 from '@/assets/images/home-cards/home-cards-2.png'
import { HeroWrapper } from '@/components/ui/hero-wrapper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

export function Categories() {
  const t = useTranslations('Services')

  return (
    <HeroWrapper className="bg-primary-50 pb-4">
      <div className="mt-14 mb-11 flex-1 px-4 md:max-w-145">
        <h1 className="md:text-heading-2 text-heading-4 text-primary-600 mb-4 font-black">
          {t('categories.title')}
        </h1>
        <p className="text-body-3 md:text-body-2 text-primary-600 leading-4.75 md:leading-6">
          {t('categories.content')}
        </p>
      </div>

      <Image
        src={HomeCard2}
        alt="services"
        width={744}
        height={400}
        fetchPriority="high"
        priority
        sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 744px"
        className="mx-auto px-4 md:max-w-90 lg:ml-auto lg:max-w-186"
      />
    </HeroWrapper>
  )
}
